import { NoneType, VelocityUnit } from "@soft-db/data-formatter";
import { createPluginOptions } from "../create-plugin-options";

export const defaultVibrationCriteriaDataOptions = createPluginOptions()({
	unit: "mm/s" as VelocityUnit | NoneType,
});

export type VibrationCriteriaDataOptions = typeof defaultVibrationCriteriaDataOptions;
